

const CheckboxButtonGroup = ({ selectedCheckbox, setSelectedCheckbox, firstLabel, secondLabel }) => {
  const handleCheckboxChange = (e) => {
  const { value, checked } = e.target;

  if (checked) {
    setSelectedCheckbox((prev) => [...prev, value]);
  } else {
    setSelectedCheckbox((prev) => prev.filter((val) => val !== value));
  }
};

    return (
        <div className="flex space-x-4 mx-4">
            <label className="flex items-center mb-2 whitespace-nowrap hover:cursor-pointer">
                <input
                    type="checkbox"
                    value={firstLabel}
                    className="mr-1 hover:cursor-pointer"
                    checked={selectedCheckbox.includes(firstLabel)}
                    onChange={handleCheckboxChange}
                />
                {firstLabel}
            </label>

            <label className="flex items-center mb-2 whitespace-nowrap hover:cursor-pointer">
                <input
                    type="checkbox"
                    value={secondLabel}
                    className="mr-1 hover:cursor-pointer"
                    checked={selectedCheckbox.includes(secondLabel)}
                    onChange={handleCheckboxChange}
                />
                {secondLabel}
            </label>
        </div>
    )
}

export default CheckboxButtonGroup
